import React, {useEffect, useState} from 'react';
import './styles/main-match-center.scss';
import {oddsFormats} from './utils/types';
import MatchCenter from "./widgets/MatchCenter";
import {getEventIdFromSeoUrl} from './utils/helpers'
import {setUpUrlStructure} from './utils/url-structure';
import {setUpBreadcrumbs} from './utils/breadcrumbs';
import {setUpInternalLinks} from './utils/internal-links';

interface IProps {
  elem: Element;
}

const MatchCenterIndex: React.FC<IProps> = ({elem}) => {
  const [widgetId, setWidgetId] = useState<number|null>(null)
  const [oddsFormat, setOddsFormat] = useState<oddsFormats>(oddsFormats.decimal)
  const [eventIdFromJs, setEventIdFromJs] = useState<number|null>(null)
  const [isAdmin, setIsAdmin] = useState<boolean>(false)

  useEffect(() => {
    // loadWidgetStyleFile('match-center-styles.css');
    const div: HTMLDivElement = elem as HTMLDivElement;

    // Setup variable
    div.dataset.urlStructure && setUpUrlStructure(JSON.parse(div.dataset.urlStructure));
    div.dataset.breadcrumbs && setUpBreadcrumbs(div.dataset.breadcrumbs);
    div.dataset.internalLinks && setUpInternalLinks(div.dataset.internalLinks);

    // Init state
    setWidgetId(div.dataset.id ? parseInt(div.dataset.id) : null)
    setOddsFormat(div.dataset.oddsFormat && Object.values(oddsFormats).includes(div.dataset.oddsFormat as oddsFormats) ? div.dataset.oddsFormat as oddsFormats : oddsFormats.decimal);
    setEventIdFromJs(div.dataset.eventId ? parseInt(div.dataset.eventId) : getEventIdFromSeoUrl(window.location.href))
    setIsAdmin(div.dataset.isAdmin === 'true')
  }, [elem])

  return (
    <>
      {widgetId && eventIdFromJs && (
        <MatchCenter
          widgetID={widgetId}
          eventIdFromJs={eventIdFromJs}
          oddsFormat={oddsFormat}
          elem={elem}
          hasCache={elem.hasChildNodes()}
          isAdmin={isAdmin}
        />
      )}
    </>
  )
}

export default MatchCenterIndex;
